module.exports = __webpack_public_path__ + "static/media/test15_2.2d23989a.png";